/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RocketWarehouseDelReqVo
 */
export interface RocketWarehouseDelReqVo {
    /**
     * 仓库ID列表
     * @type {Array<number>}
     * @memberof RocketWarehouseDelReqVo
     */
    ids: Array<number>;
}

/**
 * Check if a given object implements the RocketWarehouseDelReqVo interface.
 */
export function instanceOfRocketWarehouseDelReqVo(value: object): value is RocketWarehouseDelReqVo {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function RocketWarehouseDelReqVoFromJSON(json: any): RocketWarehouseDelReqVo {
    return RocketWarehouseDelReqVoFromJSONTyped(json, false);
}

export function RocketWarehouseDelReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RocketWarehouseDelReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function RocketWarehouseDelReqVoToJSON(json: any): RocketWarehouseDelReqVo {
    return RocketWarehouseDelReqVoToJSONTyped(json, false);
}

export function RocketWarehouseDelReqVoToJSONTyped(value?: RocketWarehouseDelReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

